import { CommonButton } from 'components/Buttons';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from 'state/actions';
import selectors from 'state/selectors';
import utils from 'utils';
import { actionType, modalActionType } from 'utils/constants';
import useCheckBeforeAction from '../hooks';

interface Props {
  isLitigationPark?: boolean;
}

const LitigationMail = (props: Props) => {
  const { isLitigationPark } = props;

  const records = useSelector(selectors.documents.selectAllActiveDocuments);
  const dispatch = useDispatch();
  const t = utils.intl.useTranslator();
  const saveDocument = utils.hooks.useSaveDocument();
  const { checkDocuments } = useCheckBeforeAction(
    isLitigationPark ? actionType.LITIGATION_PARK_MAIL : actionType.LITIGATION_MAIL,
  );
  const onClick = async () => {
    const docFree = await checkDocuments();
    if (!docFree) return;
    if ((await saveDocument()) === null) {
      return;
    }
    dispatch(actions.modal.openModal(modalActionType.documents.LITIGATION, { type: 'mail', isLitigationPark }));
  };
  return (
    <CommonButton
      id="litigation-mail-btn"
      action={onClick}
      customIcon="envelope"
      scope="tertiary"
      value={t(isLitigationPark ? actionType.LITIGATION_PARK_MAIL : actionType.LITIGATION_MAIL)}
      disabled={
        !utils.user.isActionEnabled(
          records,
          isLitigationPark ? actionType.LITIGATION_PARK_MAIL : actionType.LITIGATION_MAIL,
        )
      }
    />
  );
};

export default LitigationMail;
